import { TicketSendingOption } from '@core/data-access/models/shared/ticket-sending-options.model';
import { createActionGroup, props } from '@ngrx/store';
import { TariffUuids } from '@products/models/tariff.model';

export const TicketSendingOptionsActions = createActionGroup({
  source: 'Ticket sending options',
  events: {
    'Set ticket sending options': props<{
      selectedTicketSendingOption: TicketSendingOption;
      addBookedTariffUuids: TariffUuids;
      removeBookedTariffUuids: TariffUuids;
    }>(),
    'Remove ticket sending options': (removeTariffUuids: TariffUuids) => ({
      removeTariffUuids
    })
  }
});
